import Vue from 'vue';

export default Vue.extend({
    _isComponent: false,

    computed: {
        _logId() {
            var _ = this;

            return _._model.name + '#' + _.id;
        }
    },

    methods: {
        toJSON() {
            var _ = this,
                result = {
                    id: _.id
                };

            if (typeof _._model.instance === 'object' && typeof _._model.instance.props === 'object') {
                for (var key in _._model.instance.props) {
                    result[key] = _[key];
                }
            }

            return result;
        },

        changes() {
            var _ = this,
                lastSave = _._lastSave ? JSON.parse(_._lastSave) : {},
                current = _.toJSON(),
                result = {};

            for (var key in current) {
                if (JSON.stringify(lastSave[key]) !== JSON.stringify(current[key])) {
                    result[key] = [lastSave[key], current[key]];
                }
            }

            return result;
        },

        updateLastSaved(data) {
            var _ = this;
            _._lastSave = data || JSON.stringify(_.toJSON());
        },

        hasChanges() {
            var _ = this;
            return !!Object.keys(_.changes()).length;
        },

        save() {
            var _ = this;
            return _._model.save(_);
        },

        destroy() {
            var _ = this;
            return _._model.destroy(_);
        },

        rollback() {
            var _ = this,
                changes = _.changes();

            for (var key in changes) {
                _[key] = changes[key][0];
            }

            return _;
        }
    }
});
